/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import SelectInput from "./SelectInput";
import GetItem from "../../../helpers/dataProviders/getItem";
import parseAppKey from "../../../helpers/routeHelpers/parseAppKey";

class ThemePicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			values: [],
		};
		this.appKey = parseAppKey();
	}

	componentDidMount() {
		this.getThemes();
	}

	getThemes = () => {
		GetItem(`/apps/${this.appKey}/themes`).then(data => {
			let values = [];
			data.data.forEach(theme => {
				values.push({
					key: theme.id,
					value: theme.id,
					label: `${theme.name}`,
				});
			});
			this.setState({ values });
		});
	};

	render() {
		let { values } = this.state;
		return (
			<div className="picker-input">{values.length > 0 && <SelectInput {...this.props} values={values} />}</div>
		);
	}
}

ThemePicker.propTypes = {
	fieldState: PropTypes.object,
	fieldApi: PropTypes.object,
	placeholder: PropTypes.string,
	isRequired: PropTypes.bool,
};

export default ThemePicker;
